import useAuth from "src/hooks/selectors/useAuth";

export default function useServiceRate() {
	const auth = useAuth();
	return {
		service_rate: auth.service_rate,
	};
}
